import { ReactElement } from "react";
import { LocalizationHelperInstance } from "utils/helpers";

function useTableHelper() {
  const getTableColumnTitle = (
    title: string | ReactElement | ((repeatIndex: number) => string | React.ReactElement)
  ) => {
    if (typeof title == "string") return LocalizationHelperInstance.getFormattedMessage(title);
    else if (typeof title == "function") return undefined;
    else return title;
  };

  const getNestedTableColumnTitle = (
    title: string | ReactElement | ((repeatIndex: number) => string | React.ReactElement),
    repeatIndex?: number
  ): string | React.ReactElement => {
    if (typeof title == "string") return LocalizationHelperInstance.getFormattedMessage(title);
    else if (typeof title === "function") {
      const value = title(repeatIndex ?? 0);
      return getNestedTableColumnTitle(value);
    } else {
      return title;
    }
  };

  return { getTableColumnTitle, getNestedTableColumnTitle };
}

export default useTableHelper;
